import { getInstance } from '@/auth/authWrapper'
import cfg from '@root/config'
import { Connector } from '../../types/main'
interface LenaLeninaCredentials {
    username: string
    password: string
}

export async function login(connector: Connector, credentials: LenaLeninaCredentials) {
    const auth = getInstance()
    const token = await auth.getTokenSilently()
    const url = `${cfg.apiEndpoint}/lenaLenina/login`
    const options = {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            connector,
            credentials,
        }),
    }
    const res = await fetch(url, options)
    if (res.status === 200) {
        return true
    } else {
        return false
    }
}
export async function getSalons(projectId: string) {
    const auth = getInstance()
    const token = await auth.getTokenSilently()
    const url = `${cfg.apiEndpoint}/lenaLenina/getSalons`
    const options = {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            projectId,
        }),
    }
    const res = await fetch(url, options)
    if (res.status >= 400) {
        return { error: 'Ошибка', data: null }
    } else {
        return { error: null, data: await res.json() }
    }
}
